<style lang="scss" scoped>
.resetPwdWrapper {
  // margin-top: 30px;
  box-sizing: border-box;
  padding: 0 60px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translateX(-50%) translateY(-50%);
  margin: 20px auto;
  position: relative;
  width: 1200px;
  height: 828px;
  display: grid;
  grid-template-rows: 105px 150px 410px 1fr;
}
.noticeTop {
  color: #ff8a00;
  font-size: 20px;
}
.stepIndicator {
  border: 1px dashed #3198ff;
  background-color: #e5f2fa;
}
.stepContent {
  margin-top: 30px;
  border: 1px dashed #3198ff;
  background-color: #ebf6ff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .el-form {
    padding: 30px 40px;
    width: 300px;
    align-self: center;
    // background-color: #fff;
    margin: 0 auto;
  }
}
.switchStep {
  padding-top: 30px;
  .el-button {
    border: none;
    background-color: #ffc831;
    color: #b16614;
    border-radius: 20px;
    width: 100px;
    height: 40px;
  }
}
.stepIndicator {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 30px;
}
::v-deep .el-loading-mask {
  .el-loading-spinner {
    top: 80%;
    i {
      color: #b16614;
    }
  }
}
.el-select {
  width: 100%;
}
::v-deep {
  .el-step__head.is-process{ // 进行中
    .el-step__icon{
      background-color: #3198ff;
    }
  }
  .el-step__head.is-finish{ // 已完成
     .el-step__icon{
      background-color: #3198ff;
    }
    .el-step__line{
      background-color: #3198ff;
    }
  }
  .is-finish.el-step__title{
      color: #3198ff;
    }
  .el-step__head.is-wait{ // 等待中
     .el-step__icon{
      // background-color: #3198ff;
    }
  }
  .el-step__icon.is-text{
    border: none;
    color: white;
    background-color: #c1d7ea;
  }
  .el-step__title{
    color: #c1d7ea;
    &.is-process{
      color: #3198ff;
    }
  }
  .el-step__line{
    background-color: #c1d7ea;
  }

}
.goBack{
  position: absolute;
  right: 60px;
  top: 10px;
}
</style>
<template>
  <div class="resetPwdWrapper">
    <p class="noticeTop">根据指引完成重置密码操作 <el-button class="goBack" @click="goBack">返回</el-button></p>
    <div class="stepIndicator">
      <el-steps :active="activeIndex -1" align-center>
        <el-step title="填写信息"></el-step>
        <el-step title="重置密码"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div>
    <div class="stepContent">
      <div v-show="activeIndex === 1">
        <el-form :model="certForm" ref="certForm" :rules="rules">
          <el-form-item prop="admission_ticket">
            <el-input v-model="certForm.admission_ticket" placeholder="请输入准考证号码"></el-input>
          </el-form-item>
          <el-form-item prop="name">
            <el-input v-model="certForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item prop="certificate_type">
            <el-select class="certype" v-model="certForm.certificate_type" placeholder="请选择证件类型">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="certificates">
            <el-input v-model="certForm.certificates" placeholder="请输入证件号"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="activeIndex === 2">
        <el-form :model="pwdForm" ref="pwdForm" :rules="pwdRules">
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="pwdForm.password"
              placeholder="请输入新密码"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="npassword">
            <el-input
              type="password"
              v-model="pwdForm.npassword"
              placeholder="请再次输入新密码"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="activeIndex === 3">
        恭喜您已经成功重置密码，点击完成按钮重新登录！
      </div>
    </div>
    <div class="switchStep">
      <el-button v-show="activeIndex > 1 && activeIndex<3" @click="handlePrevStep">上一步</el-button>
      <el-button
        :disabled="loading"
        element-loading-spinner="el-icon-loading"
        v-loading="loading"
        v-show="activeIndex < 3"
        @click="handleNextStep"
      >下一步</el-button>
      <el-button v-show="activeIndex === 3" @click="handleNextStep">完成</el-button>

    </div>
  </div>
</template>
<script>
import { postResetPwd } from '@/services/getData';

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (this.pwdForm.password === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.pwdForm.password !== '') {
          this.$refs.pwdForm.validateField('npassword');
        }
        callback();
      }
    };
    const validateNPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.pwdForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      activeIndex: parseInt(this.$route.params.step, 10),
      certForm: {
        name: '',
        admission_ticket: '',
        certificates: '',
        certificate_type: '',
      },
      pwdForm: {
        password: '',
        npassword: '',
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'change' }],
        admission_ticket: [
          { required: true, message: '请输入准考证号', trigger: 'change' },
        ],
        certificates: [
          { required: true, message: '请输入证件号', trigger: 'change' },
        ],
        certificate_type: [
          { require: true, message: '请选择证件类型', trigger: 'change' },
        ],
      },
      pwdRules: {
        password: [
          {
            validator: validatePass,
          },
        ],
        npassword: [
          {
            validator: validateNPass,
          },
        ],
      },
      options: [
        {
          value: '1',
          label: '身份证',
        }, {
          value: '2',
          label: '护照',
        }, {
          value: '3',
          label: '学籍号码',
        },
        {
          value: '4',
          label: '户口本',
        },
      ],
      loading: false,
    };
  },
  methods: {
    handleNextStep() {
      if (this.activeIndex === 1) {
        this.$refs.certForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            postResetPwd(this.certForm)
              .then((resp) => {
                this.loading = false;
                console.log(resp);
                this.$router.push(
                  `/user/resetpassword/${parseInt(this.$route.params.step, 10)
                    + 1}`,
                );
              })
              .catch((err) => {
                this.loading = false;
                if (err && err.status === 422) {
                this.$message.error(err.data.message);
              } else {
                this.$message.error('操作失败');
              }
              });
          }
        });
      } else if (this.activeIndex === 2) {
        this.$refs.pwdForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            postResetPwd(
              Object.assign({ password: this.pwdForm.password }, this.certForm),
            )
              .then((resp) => {
                this.loading = false;
                this.$router.push(
                  `/user/resetpassword/${parseInt(this.$route.params.step, 10)
                    + 1}`,
                );
              })
              .catch((err) => {
                this.loading = false;
                if (err && err.status === 422) {
                this.$message.error(err.data.message);
              } else {
                this.$message.error('操作失败');
              }
              });
          }
        });
      } else if (this.activeIndex === 3) {
        // localStorage.clear();
        localStorage.removeItem('authority');
        localStorage.removeItem('currentUser');
        window.location.href = '/login';
      }
    },
    handlePrevStep() {
      this.$router.push(
        `/user/resetpassword/${parseInt(this.$route.params.step, 10) - 1}`,
      );
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  components: {},
  created() {},
  mounted() {
    if (!this.certForm.certificate) {
      this.$router.push('/user/resetpassword/1');
    }
  },
  props: {},
  watch: {
    $route: {
      handler(value) {
        console.log(value);
        this.activeIndex = parseInt(value.params.step, 10);
      },
      deep: true,
    },
  },
};
</script>
